import React from "react";

const Langs = (props) => {
	return <>Langs</>;
};

export default Langs;
